const Colors = {
  white: "#ffffff",
  black: "#000000",
  mineShaft: "#3C3C3C",
  doveGray: "#646464",
  orient: "#00567a",
  violetEggplant: "#aa198d",
  blumine: "#1f4e77",
  silver: "#c8c8c8",
  oracle: "#3c7e79",
  alabaster: "#f8f8f8",
  greenHaze: "#00a03b",
  mercury: "#e6e6e6",
  aquaDeep: "#00594c",
  gray: "#8c8c8c",
  alto: "#dcdcdc",
  valencia: "#d73131",
  emperor: "#505050",
  chestnuteRose: "#cf4b4b",
  orangePeel: "#ff9900",
  coralRed: "#fb3449",
  scienceBlue: "#0A58CA",
  aquaDeepHover: "#01473c",
};

export default Colors;
